import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { OfferService } from '../../../offer/offer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html'
})
export class OffersComponent implements OnInit {

    @Input() clientKey: any;
    @Input() displayHeader: boolean = true;
    offers: any = [];

    constructor(public translate: TranslateService,
        private apiService: ApiService,
        private offerService: OfferService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngOnInit() {
        if (this.clientKey)
            this.getOffers();
    }

    getOffers() {
        var model = {
            ClientCde: this.clientKey,
            IsOfferOnlyInd: 'B',
            PageSize: 1000,
            SortOrder: 'Desc',
            SortField: ''
        };

        this.apiService.post("Api/QuoteApi/Search/", model).subscribe((result: any) => {

            var offers = [];

            for (var offerKey in result.rows) {
                if(!result.rows[offerKey].PolExtCode ||
                    result.rows[offerKey].PolStatusCde == 4)
                 offers.push(result.rows[offerKey]);
            }

            this.offers = offers;
        });
    }

    goToOffer(offer) {
        this.offerService.clientCode = this.clientKey;
        this.offerService.departmentCode = offer.DepartmentCde;
        this.offerService.offerHeaderKey = offer.OfferHeaderKey;
        this.offerService.processCode = offer.ProcessCde;
        this.offerService.productCode = offer.ProductCde;
        this.offerService.versionNo = offer.VersionNo;

        this.router.navigate(["../../../Offer/New"], { relativeTo: this.route });
    }

    goToQuote() {

    }

    //Used for scrollable cards
    public config: PerfectScrollbarConfigInterface = {
        suppressScrollX: false,
        wheelPropagation: false,
        useBothWheelAxes: true
    };

}
